import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'join',
  pure: true
})
export class JoinPipe implements PipeTransform {

  transform(value: any|any[], ...args: any[]): any {
    if (!value) return '';
    if(!Array.isArray(value)) 
      value = [value];
    var seperator = args[0] || ' , ', field = args[1];
    return value.map(_ => !_ ? null : field ? eval(`_.${field}`) : _).filter(_ => _).join(seperator);
  }

}
